var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivityLogIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4237 18.3913C22.4214 16.8356 23 14.9854 23 13C23 7.47715 18.5228 3 13 3C10.0383 3 7.37738 4.2875 5.54631 6.33333M18.5486 21.3207C16.961 22.3815 15.0527 23 13 23C7.47715 23 3 18.5228 3 13C3 12.7615 3.00835 12.5249 3.02478 12.2905M5.54631 6.33333H8.2381M5.54631 6.33333L5.85714 3.47619",
    stroke: "#11334E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5237 9.66699V13.6352L15.0038 16.1154",
    stroke: "#11334E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityLogIcon);
export default __webpack_public_path__ + "static/media/activityLogIcon.ecac96db1f94ac7e2d283049c441ce07.svg";
export { ForwardRef as ReactComponent };